// Copyright (c) Ping. All rights reserved.
//
// Web host shim around the shared `<ChatEmptyState>` from `@ping/ui`.
// All presentation moved into packages/ui/src/chat/ChatEmptyState.tsx.

import { ChatEmptyState as ChatEmptyStateUi } from '@ping/ui';

interface ChatEmptyStateProps {
  onNewChatPress: () => void;
}

export function ChatEmptyState({ onNewChatPress }: ChatEmptyStateProps) {
  return <ChatEmptyStateUi onNewChatPress={onNewChatPress} />;
}
